export { default as FacilityOrderPatientNewFlowUSIntakeSinglePagePreviewTemplate } from './FacilityOrderPatientNewFlowUSIntakeSinglePagePreviewTemplate';